import * as React from 'react';
import {Adsense} from '@ctrl/react-adsense';

export default function VerticalAdSense() {
  return (
    <span>
      <Adsense
        client="ca-pub-5408817825867636"
        slot="6016261358"
        style={{ display: 'block' }}
        format="auto"
        responsive="true"
      />
    </span>
  );
}
